/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type COMMENT_SORT = "CREATED_AT_ASC" | "CREATED_AT_DESC" | "REACTION_DESC" | "REPLIES_DESC" | "%future added value";
export type RemoveAnsweredLocal = {
    readonly commentsOrderBy: COMMENT_SORT;
    readonly refreshStream: boolean | null;
    readonly " $refType": "RemoveAnsweredLocal";
};
export type RemoveAnsweredLocal$data = RemoveAnsweredLocal;
export type RemoveAnsweredLocal$key = {
    readonly " $data"?: RemoveAnsweredLocal$data;
    readonly " $fragmentRefs": FragmentRefs<"RemoveAnsweredLocal">;
};



const node: ReaderFragment = ({
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "RemoveAnsweredLocal",
    "selections": [
        {
            "kind": "ClientExtension",
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "commentsOrderBy",
                    "storageKey": null
                },
                {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "refreshStream",
                    "storageKey": null
                }
            ]
        }
    ],
    "type": "Local",
    "abstractKey": null
} as any);
(node as any).hash = '0e0edc3178e978119fc131b8dc4eb3da';
export default node;
